import { render } from "./ReceiptView.vue?vue&type=template&id=226852e7&scoped=true"
import script from "./ReceiptView.vue?vue&type=script&lang=js"
export * from "./ReceiptView.vue?vue&type=script&lang=js"

import "./ReceiptView.vue?vue&type=style&index=0&id=226852e7&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226852e7"]])

export default __exports__